import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, Subject } from 'rxjs';
import { SignUp } from 'src/app/model/request/auth';
import { LoginResponse } from 'src/app/model/response/auth-r';
import { BaseResponse } from 'src/app/model/response/base-response';
import { Role } from 'src/app/model/user';
import { RolesService } from 'src/app/services/roles.service';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-register',
  templateUrl: './signup.component.html',
  styleUrls: ['../login.component.scss', './signup.component.scss'],
  providers: [DatePipe]
})

export class SignUpComponent implements OnInit {
  // create strict typed angular form, preaty neat
  formSignUp = new FormGroup({
    username: new FormControl<string>('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.minLength(1),
    ]),
    email: new FormControl<string>('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.minLength(1),
    ]),
    password: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    passwordConfirm: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(8),
    ]),
    //ruolo: new FormControl<string>('', [Validators.required]),
  });

  formHaveErrors: boolean = false;
  passwIcon: string = 'e-icons cursor-pointer spass';
  errMsg: string = '';
  rispSignUp!: BaseResponse;
  clientTypeIsSelected: boolean= false;

  //dropdown options
  public dropdownValue: string = '';
  public dropdownData: Role[] = [];


  //subjects for displaying errors while writing data on the form
  private pwdConfirmSubject$: Subject<string> = new Subject<string>();
  private pwdValidSubject$: Subject<string> = new Subject<string>();
  private mailValidSubject$: Subject<string> = new Subject<string>();
  private usernameExistsSubject$: Subject<string> = new Subject<string>();

  //needed for form validation on signup method call
  public pwdError: boolean = true;
  public pattern: RegExp = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&.:,;])[A-Za-zd$@$!%*?&.:,;].{8,32}');
  public patternMail: RegExp = new RegExp('^[^@]+@[^@]+$');
  public pwdNotValid: boolean = false;
  public mailNotValid: boolean = false;
  public mailExists: boolean = false;
  public usernameExists: boolean = false;
  token: string|undefined;
  isCompleted: boolean= false;
  showForm: boolean=true;



  constructor(
    private loginService: LoginService,
    private roleService:RolesService,
    private router: Router,
    private datePipe: DatePipe,
  ) {
    this.passwIcon += ' e-eye';
  }



  ngOnInit(): void {

    //needed for displaying real time errors on form
    this.pwdConfirmSubject$.pipe(debounceTime(500)).subscribe({
      next: (value: string) => {
        if (value != this.formSignUp.value.password) {
          this.pwdError = false;
        } else {
          this.pwdError = true;
        }
      },
    });
    this.pwdValidSubject$.pipe(debounceTime(500)).subscribe({
      next: (value: string) => {
        let a = this.pattern.test(value);
        console.log(a);
        if (this.pattern.test(value)) {
          this.pwdNotValid = false;
        } else {
          this.pwdNotValid = true;
        }
      },
    });

    this.mailValidSubject$.pipe(debounceTime(800)).subscribe({
      next: (value: string) => {
        let a = this.patternMail.test(value);
        console.log(a);
        if (this.patternMail.test(value)) {
          this.loginService.emailExists(value).subscribe({
            next:(value:boolean)=>{
              this.mailExists=value;
            },
            error:(value:any)=>{
              console.error("impossibile controllare l'email")
            }
          });
          this.mailNotValid = false;
        } else {
          this.mailNotValid = true;
        }
      },
    });

    this.usernameExistsSubject$.pipe(debounceTime(800)).subscribe({
      next: (value: string) => {
        this.loginService.usernameExists(value).subscribe({
          next:(value:boolean)=>{
            this.usernameExists=value;
          },
          error:(value:any)=>{
            console.error("impossibile controllare l'username")
          }
        });
      },
    });
  }

  pwdCheck(pwdC: string) {
    this.pwdConfirmSubject$.next(pwdC);
  }

  pwdValidation(pwd: string) {
    this.pwdValidSubject$.next(pwd);
  }
  mailValidation(mail: string) {
    this.mailValidSubject$.next(mail)
  }
  usernameValidation(username: string) {
    this.usernameExistsSubject$.next(username)
  }

  getRole(type:string){

    if(type=='dipendente'){
      this.roleService.getDipendenti().subscribe({
        next:(response:Role[])=>{
          this.dropdownData = response;
        }
      });
      this.showForm=true;
      this.clientTypeIsSelected=true;
    }else{
      if(type=='cliente'){
        this.roleService.getClienti().subscribe({
          next:(response:Role[])=>{
            this.dropdownData = response;
          }
        });
        this.clientTypeIsSelected=true;
        this.showForm=true;
      }else{
        if(type=='typeSelect'){
          this.clientTypeIsSelected=false;
          this.showForm=false;
        }
      }
    }

  }

  signUp() {
    if (this.formSignUp.invalid) {
      this.errMsg = 'Compila tutti i campi';
      this.formHaveErrors = true;
      console.error(
        'Errors in form validation, check the inserted data and try again'
      );
      return;
    }



    let date = this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss');
    let role:string[]=[];
    //let roleSelected= this.formSignUp.value.ruolo || '';
    //role = [... role, roleSelected];

    let userToRegister: SignUp = {
      username: this.formSignUp.value.username || '',
      email: this.formSignUp.value.email || '',
      role: role,
      password: this.formSignUp.value.password || '',
      creationDate: date || '',
    };

    if (
      userToRegister.username == '' ||
      userToRegister.email == '' ||
      userToRegister.role.length == 0 ||
      userToRegister.password == '' ||
      userToRegister.creationDate == ''
    ) {
      this.errMsg = 'Compila tutti i campi';
      this.formHaveErrors = true;
    }
    this.loginService.signUpUser(userToRegister,false).subscribe({
      next: (response: LoginResponse) => {
        this.rispSignUp = response.response;
        if (response.response.success == true) {
          this.showForm=false;
          this.isCompleted=true;
        }
      },
      error: (response: LoginResponse) => {
        console.error('Error while registering');
        console.error(response.response.error);
        this.formHaveErrors = true;
        this.errMsg = response.response.error;
      },
    });
  }

  showPassword() {
    const pwdI = document.getElementById('pwdInput');
    const pwdIc = document.getElementById('pwdInputConfirm');
    if (this.passwIcon.includes('-slash')) {
      this.passwIcon = this.passwIcon.replace('-slash', '');
      pwdI?.setAttribute('type', 'password');
      pwdIc?.setAttribute('type', 'password');
      console.log('removed slash');
    } else {
      this.passwIcon += '-slash';
      pwdI?.setAttribute('type', 'text');
      pwdIc?.setAttribute('type', 'text');
      console.log('added slash');
    }
  }

  route(){
    this.router.navigate(['/auth/login']);
  }

  public send(form: NgForm): void {
    if (form.invalid) {
      for (const control of Object.keys(form.controls)) {
        form.controls[control].markAsTouched();

      }

      return;
    }
    console.debug(`Token [${this.token}] generated`);
  }
}
